import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { VideoCameraAddOutlined } from '@ant-design/icons';


const Home = () => {
    const [form] = Form.useForm();
    const [, forceUpdate] = useState({});
    let navigate = useNavigate();

    useEffect(() => {
        forceUpdate({});
      }, []);
      const onFinish = (values) => {
        navigate(`/${values.id}`);
      };
    
    return (
        <div className="bg-home">
            <div><img src="/static/images/vivmedic-white.png" className="logo" alt="logo" /></div>
            <div className="home-title">Vivmedic Meet v1.0</div>
            <div className="home-slogan">Kế nối ở mọi nơi với Vivmedic Meet</div>

            <Form form={form} className="form-connect"  onFinish={onFinish}>
                <Form.Item
                    name="id"
                    rules={[{ required: true, message: 'Vui lòng nhập mã cuộc hội thoại' }]}
                >
                    <Input prefix={<VideoCameraAddOutlined />} className="input-code" autoComplete="off" placeholder="Nhập mã cuộc hội thoại" />
                </Form.Item>
                
                <Form.Item shouldUpdate>
                    {() => (
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="btn-connect"
                            disabled={
                                !form.isFieldsTouched(true) ||
                                !!form.getFieldsError().filter(({ errors }) => errors.length).length
                            }
                        >
                            Tham gia
                        </Button>
                    )}
                </Form.Item>
            </Form>

        </div>
    )
}
export default Home;